import { cn } from '@/lib/utils';
import { Button } from './button';

/**
 * Reusable empty state component with consistent styling
 * 
 * @param {React.ElementType} icon - Lucide icon component
 * @param {string} title - Title text
 * @param {string} description - Description text
 * @param {string} actionLabel - Button label (optional)
 * @param {function} onAction - Button click handler (optional)
 * @param {string} className - Additional CSS classes
 */
export const EmptyState = ({
  icon: Icon,
  title,
  description,
  actionLabel,
  onAction,
  className,
  children,
}) => {
  return (
    <div className={cn(
      "flex flex-col items-center justify-center py-12 px-6 text-center",
      className
    )}>
      {Icon && (
        <div className="h-16 w-16 rounded-2xl bg-neutral-100 dark:bg-neutral-800 flex items-center justify-center mb-4">
          <Icon className="h-8 w-8 text-neutral-400" strokeWidth={1.5} />
        </div>
      )}
      <h3 className="text-lg font-semibold text-black dark:text-white mb-2">
        {title}
      </h3>
      <p className="text-sm text-neutral-500 dark:text-neutral-400 max-w-sm mb-6">
        {description}
      </p>
      {actionLabel && onAction && (
        <Button 
          onClick={onAction}
          className="bg-black text-white hover:bg-neutral-800 dark:bg-white dark:text-black dark:hover:bg-neutral-200"
        >
          {actionLabel}
        </Button>
      )}
      {children}
    </div>
  );
};

export default EmptyState;
